export default "__VITE_ASSET__BUJiPK$k__"